export const filterItem = [
  {
    categoryName: "Technology",
  },
  {
    categoryName: "Clothing",
  },
  {
    categoryName: "Cosmetics",
  },
  {
    categoryName: "Furniture",
  },
  {
    categoryName: "Accessories",
  },
];
